module.exports = __webpack_public_path__ + "img/board.3b869c5a.png";